import { styled } from '@material-ui/core/styles'
import Pagination from 'material-ui-flat-pagination'

export const PaginationStyles = styled(Pagination)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 'normal',
  color: theme.palette.grey.dark,
  '& button': {
    fontFamily: 'Source Serif Pro',
    height: 32,
    width: 32,
    padding: 0,
    paddingTop: 0,
    paddingBottom: 0,
    borderRadius: '50%',
    textAlign: 'center',
    fontWeight: 'normal',
    '& span': {
      display: 'flex',
      textAlign: 'center',
      height: '100%',
      paddingLeft: 1,
    },
  },
  '& .MuiFlatPageButton-textSecondary': {
    height: 32,
    width: 32,
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.common.white,
  },
}))
